import type { Doc } from "building-types/doc";
import type { OptionChoices } from "building-types/options/optionChoices";
import type { FeatureSet } from "common/constants/features";
import type { Vec2 } from "geom/vec2";
import type { TitleSheetInfo } from "lib/house/plans/titleSheetInfo";
import type { BuildingGenerationFailureDetails } from "lib/workers/buildingGenerationDiagnostic";

export enum PDFErrorType {
  INTERNAL = "INTERNAL",
  USER = "USER",
}

export interface PDFWorkerError {
  errorType: PDFErrorType;
  message?: string;
  /** Set only on the main-thread export paths; a worker payload cannot cross `postMessage`. */
  details?: BuildingGenerationFailureDetails;
}

export const BUILDING_GENERATION_USER_MESSAGE =
  "This plan's file has a problem and the building could not be generated. Please contact support for help.";

export type PDFWorkerToMainMessage =
  | GetSVGBoundingBoxMessage
  | FetchImageSizeMessage
  | ErrorMessage
  | FinishMessage
  | ProgressMessage;

export interface GetSVGBoundingBoxMessage {
  type: "getSVGBoundingBox";
  requestId: string;
  svgString: string;
}

export interface FetchImageSizeMessage {
  type: "fetchImageSize";
  requestId: string;
  url: string;
}

export interface ProgressMessage {
  type: "progress";
  data: number;
}

export interface ErrorMessage {
  type: "error";
  errorType: PDFErrorType;
  message?: string;
  /** True when the modal should substitute user-facing building generation copy. */
  isBuildingGenerationFailure?: boolean;
}

export interface FinishMessage {
  type: "finish";
  data: string;
}

export type PDFMainToWorkerMessage = FetchImageSizeResponse | BeginPDFGenerationMessage;

export interface FetchImageSizeResponse {
  type: "fetchImageSize";
  requestId: string;
  size: Vec2;
}

export interface BeginPDFGenerationMessage {
  type: "beginPDFGeneration";
  name: string;
  optionChoices: OptionChoices;
  doc: Doc;
  titleSheetInfo?: TitleSheetInfo;
  watermark: boolean;
  enabledFeatures?: FeatureSet;
}
